"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.HLSSource = void 0;
var React = __importStar(require("react"));
var hls_js_1 = __importDefault(require("hls.js"));
var video_context_1 = require("../context/video-context");
var react_1 = require("@xstate/react");
var selectors_1 = require("../selectors");
/**
 * Wrapper for the hls.js library that attaches to an active video element
 * and allows us to load m3u8 (hls) streaming video
 *
 * @see {@link https://github.com/devcshort/react-hls/blob/master/src/index.tsx}
 * @param src
 * @param type
 * @param hlsConfig
 * @constructor
 */
var HLSSource = function (_a) {
    var src = _a.src, _b = _a.type, type = _b === void 0 ? 'application/x-mpegURL' : _b, hlsConfig = _a.hlsConfig;
    var videoService = (0, video_context_1.useVideo)();
    var video = (0, react_1.useSelector)(videoService, selectors_1.selectVideo);
    React.useEffect(function () {
        var hls;
        if (!video)
            return;
        function _initPlayer() {
            if (hls) {
                hls.destroy();
            }
            hls = new hls_js_1["default"](__assign({ enableWorker: false }, hlsConfig));
            if (video) {
                hls.attachMedia(video);
            }
            hls.on(hls_js_1["default"].Events.MEDIA_ATTACHED, function () {
                hls.loadSource(src);
            });
            hls.on(hls_js_1["default"].Events.ERROR, function (event, data) {
                console.error('HLS streaming error', { event: event, data: data });
                if (data.fatal) {
                    switch (data.type) {
                        case hls_js_1["default"].ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case hls_js_1["default"].ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            _initPlayer();
                            break;
                    }
                }
            });
        }
        var canUseNative = video.canPlayType('application/vnd.apple.mpegurl');
        var shouldUseNative = canUseNative && !hls_js_1["default"].isSupported();
        function handleExitedFullscreenOnIphone() {
            videoService.send('PAUSE');
        }
        // Check for Media Source support
        if (!shouldUseNative) {
            _initPlayer();
        }
        else {
            video.load();
            video.addEventListener('webkitendfullscreen', handleExitedFullscreenOnIphone, false);
        }
        return function () {
            if (hls) {
                hls.destroy();
            }
            video.removeEventListener('webkitendfullscreen', handleExitedFullscreenOnIphone);
        };
    }, [hlsConfig, video, src, videoService]);
    // Fallback to using a regular video player if HLS is supported by default in the user's browser
    return React.createElement("source", { src: src, type: type });
};
exports.HLSSource = HLSSource;
